/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
import Tab from '../../component/Inc/Tab';
import PopManagingCompany from './_PopManagingCompany';
// I found some differency with design. check design image plz
// Change overall code. there are duplicated codes and unnecessary codes.
const BookPriceCalculate = () => {
  const [tabIdx, setTabIdx] = useState(0);

  const tab = [
    {title: '제일인쇄소', value: 0},
    {title: '서울제본', value: 1},
    {title: '망향인쇄소', value: 2},
    {title: '경기도 인쇄소', value: 3},
    {title: '제일인쇄소', value: 4},
    {title: '서울제본', value: 5}
  ];

  const [modalManagingCompanyOpen, setModalManagingCompanyOpen] = useState(false);
  return (
    <main className="com_container com_books p_book_price_calculate">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_9">교재 단가 계산기</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_settings">교재 관리</button>
            <button onClick={() => setModalManagingCompanyOpen(true)} className="com_btn orange s btn_settings">
              제작처 관리
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <div className="tab">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
                <div className="com_calendar_wrap">
                  <div className="year">
                    <button className="btn btn_next"></button>
                  </div>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
          </section>

          <section className="box box-half">
            <div className="com_card_list">
              <div className="card_item">
                <div className="item_top">
                  <div className="title">&lt; 제일인쇄소 &gt;</div>
                </div>
                <div className="item_mid">
                  <div className="com_board_box">
                    <div className="board_item">
                      <div className="info">
                        <span className="tit">담당자</span>
                        <span className="cont ">김당담</span>
                        <button className="com_icon darkGray">사업자 등록증 다운로드</button>
                      </div>
                      <div className="info">
                        <span className="tit">연락처</span>
                        <span className="cont">010-1234-2314 / 02-2134-3124</span>
                      </div>
                      <div className="info">
                        <span className="tit">주소</span>
                        <span className="cont">경기도 포천시 포천대로103 234호</span>
                        <div className="right_item">
                          <button className="btn_edit"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="15%" />
                <col width="11%" />
                <col width="24%" />
                <col width="25%" />
                <col width="25%" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>용도</th>
                  <th>종이 / 평량</th>
                  <th>국전(939x636)</th>
                  <th>4*6(788X545)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan="3" className="bg_color">
                    용지대
                  </td>
                  <td className="bg_color">표지</td>
                  <td>스노우 250</td>
                  <td className="td_right">90,000</td>
                  <td className="td_right">
                    <button className="btn btn_minus_gray" />
                    <span className="txt">120,000</span>
                  </td>
                </tr>
                <tr>
                  <td className="border_left bg_color">면지</td>
                  <td>스노우 150</td>
                  <td className="td_right">75,000</td>
                  <td className="td_right">
                    <button className="btn btn_add_gray" />
                    <span className="txt">83,000</span>
                  </td>
                </tr>
                <tr>
                  <td className="border_left bg_color">내지</td>
                  <td>뉴클래식80</td>
                  <td className="td_right">41,500</td>
                  <td className="td_right">
                    <button className="btn btn_add_gray" />
                    <span className="txt">56,000</span>
                  </td>
                </tr>
                <tr>
                  <td rowSpan="7" className="bg_color">
                    인쇄대당 단가
                  </td>
                  <td rowSpan="4" className="bg_color">
                    내지
                  </td>
                  <td>~80g미만</td>
                  <td className="td_right">6,000</td>
                  <td className="td_right">9,000</td>
                </tr>
                <tr>
                  <td className="border_left">~100g미만</td>
                  <td className="td_right">5,000</td>
                  <td className="td_right">8,000</td>
                </tr>
                <tr>
                  <td className="border_left">~150g미만</td>
                  <td className="td_right">4,500</td>
                  <td className="td_right">7,000</td>
                </tr>
                <tr>
                  <td className="border_left">~200g미만</td>
                  <td className="td_right">2,800</td>
                  <td className="td_right">
                    <button className="btn btn_add_gray" />
                    <span className="txt">5,000</span>
                  </td>
                </tr>
                <tr>
                  <td rowSpan="3" className="border_left bg_color">
                    표지/면지
                  </td>
                  <td>~3R미만</td>
                  <td className="td_right">7,000</td>
                  <td className="td_right">9,000</td>
                </tr>
                <tr>
                  <td className="border_left">~5R미만</td>
                  <td className="td_right">5,000</td>
                  <td className="td_right">
                    <button className="btn btn_add_gray" />
                    <span className="txt">8,000</span>
                  </td>
                </tr>
                <tr>
                  <td className="border_left">~7R미만</td>
                  <td className="td_right">4,000</td>
                  <td className="td_right">7,000</td>
                </tr>
                <tr>
                  <td colSpan="2" className="bg_color">
                    CTP
                  </td>
                  <td></td>
                  <td></td>
                  <td className="td_right">8,000</td>
                </tr>
                <tr>
                  <td rowSpan="4" colSpan="2" className="bg_color">
                    코팅
                  </td>
                  <td>엠보 코팅</td>
                  <td className="td_right">100,000</td>
                  <td className="td_right">120,000</td>
                </tr>
                <tr>
                  <td className="border_left">라미네이팅 무광</td>
                  <td className="td_right">90,000</td>
                  <td className="td_right">90,000</td>
                </tr>
                <tr>
                  <td className="border_left">라미네이팅 유광</td>
                  <td className="td_right">5,0000</td>
                  <td className="td_right">70,000</td>
                </tr>
                <tr>
                  <td className="border_left">에폭시</td>
                  <td className="td_right">130,000</td>
                  <td className="td_right">150,000</td>
                </tr>
              </tbody>
            </table>

            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">계약 내용 수정하기</button>
            </div>
          </section>
          <section className="box box-half">
            <div className="detail_tit dot">교재 제작 단가 계산기</div>

            <table className="com_board_list type_row">
              <colgroup>
                <col width="22%" />
                <col width="73%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>교재명</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="과목 선택">과목 선택</option>
                      </select>
                      <select className="select">
                        <option value="교재 선택">교재 선택</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>제작 부수</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`3000`} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="table_wrapper">
              <div className="detail_tit bold">표지 용지대</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>사이즈</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="input_box">W</div>
                        <span className="txt">x</span>
                        <div className="input_box">H</div>
                        <div className="txt">인쇄 종이 : 국전 (939 X 636) l 16page</div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>책등, 날개 사이즈</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="input_box">W</div>
                        <span className="txt">x</span>
                        <div className="input_box">W</div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>종이</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="스노우250g">스노우250g</option>
                        </select>
                        <span className="txt">연단가 : 28,000</span>
                        <input type="text" className="input end" defaultValue={`여분(장) : 100`} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>제작 페이지 수</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <input type="text" className="input" defaultValue={`24page`} />
                        <span className="txt">필요종이 : 1.5연</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>금액 ( a X b)</th>
                    <td className="td_left">
                      <span className="com_blue_txt">28,000 × 1.5 = 195,000원</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">내지 용지대</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>사이즈</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="input_box">W</div>
                        <span className="txt">x</span>
                        <div className="input_box">H</div>
                        <div className="txt">인쇄 종이 : 국전 (939 X 636) l 16page</div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>종이</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="스노우250g">스노우250g</option>
                        </select>
                        <span className="txt">연단가 : 28,000</span>
                        <input type="text" className="input end" defaultValue={`여분(장) : 100`} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>제작 페이지 수</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <input type="text" className="input" defaultValue={`24page`} />
                        <span className="txt">필요종이 : 1.5연</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>금액 ( a X b)</th>
                    <td className="td_left">
                      <span className="com_blue_txt">28,000 × 1.5 = 195,000원</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">면지 용지대</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>사이즈</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="input_box">W</div>
                        <span className="txt">x</span>
                        <div className="input_box">H</div>
                        <div className="txt">인쇄 종이 : 국전 (939 X 636) l 16page</div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>종이</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="스노우250g">스노우250g</option>
                        </select>
                        <span className="txt">연단가 : 28,000</span>
                        <input type="text" className="input end" defaultValue={`여분(장) : 100`} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>제작 페이지 수</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <input type="text" className="input" defaultValue={`24page`} />
                        <span className="txt">필요종이 : 1.5연</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>금액 ( a X b)</th>
                    <td className="td_left">
                      <span className="com_blue_txt">28,000 × 1.5 = 195,000원</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">추가 가공</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>라미네이팅</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">무광 90,000</label>
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">유광 80,000</label>
                        </div>
                        <div className="price">
                          <span className="txt">× 1.5 = </span>
                          <span className="txt com_blue_txt"> 135,000원</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>코팅</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">엠보코팅100,000</label>
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">에폭시 150,000</label>
                        </div>
                        <span className="txt gap">× 1.5 = </span>
                        <span className="txt com_blue_txt"> 135,000원</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">특수공정</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <input type="text" className="input" placeholder="내용입력" />
                    </th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div>
                          <input type="text" className="input" placeholder="내용입력" />
                        </div>
                        <div>
                          <input type="text" className="input" placeholder="내용입력" />
                        </div>
                        <button className="btn_add_gray"></button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">인쇄</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>표지 인쇄</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="4도양면">4도양면</option>
                        </select>
                        <span className="txt gap">1.5연 × 6,000 × 8 =</span>
                        <span className="txt com_blue_txt"> 58,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>내지 인쇄</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="1도양면">1도양면</option>
                        </select>
                        <span className="txt gap">5.5연 x 6,000 x 8 =</span>
                        <span className="txt com_blue_txt"> 845,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>면지 인쇄</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="4도양면">4도양면</option>
                        </select>
                        <span className="txt gap">2.0연 x 6,000 x 8</span>
                        <span className="txt com_blue_txt"> = 58,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>금액</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <span className="txt gap">58,000 + 845,000 + 58,000 =</span>
                        <span className="txt com_blue_txt"> 789,000</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table_wrapper">
              <div className="detail_tit bold">총 제작 금액</div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="22%" />
                  <col width="73%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>용지대</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <span className="txt com_blue_txt"> 7,195,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>추가 가공</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <span className="txt com_blue_txt"> 789,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>인쇄</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <span className="txt com_blue_txt"> 649,000</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>총 제작금액 / 권당 금액</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <span className="txt com_blue_txt">78,195,000 / 3000 = 45,000</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap center">
              <button className="com_btn orange s">계 산</button>
            </div>
          </section>
        </section>
      </div>
      <PopManagingCompany open={modalManagingCompanyOpen} close={() => setModalManagingCompanyOpen(false)} />
    </main>
  );
};

export default BookPriceCalculate;
